(function () {
  var drawer = document.getElementById('vayl-cart-drawer');
  var overlay = document.getElementById('vayl-cart-overlay');
  var closeBtn = document.getElementById('vayl-cart-close');
  var cartToggle = document.getElementById('vayl-cart-toggle');
  var itemsEl = document.getElementById('vayl-cart-items');
  var subtotalEl = document.getElementById('vayl-cart-subtotal');
  var shippingMsgEl = document.getElementById('vayl-shipping-msg');
  var shippingFillEl = document.getElementById('vayl-shipping-fill');
  var upsellEl = document.getElementById('vayl-cart-upsell');
  var upsellListEl = document.getElementById('vayl-cart-upsell-list');
  var discountInput = document.getElementById('vayl-discount-input');
  var discountApplyBtn = document.getElementById('vayl-discount-apply');
  var discountMsgEl = document.getElementById('vayl-discount-msg');
  var checkoutBtn = document.getElementById('vayl-checkout-btn');
  var protectionToggle = document.getElementById('vayl-protection-toggle');
  var PROTECTION_VARIANT_ID = protectionToggle ? protectionToggle.getAttribute('data-variant-id') : null;
  var PROTECTION_OFF_KEY = 'vayl_protection_off';
  var FREE_SHIPPING_THRESHOLD = 5000;
  var protectionAutoAddInFlight = false;

  if (!drawer || !overlay || !itemsEl) return;

  var UPSELL_PRODUCTS = [];
  try {
    var upsellDataEl = document.getElementById('vayl-upsell-products');
    if (upsellDataEl) UPSELL_PRODUCTS = JSON.parse(upsellDataEl.textContent);
  } catch (e) { UPSELL_PRODUCTS = []; }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.style.transform = 'translateX(0)';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.style.transform = 'translateX(100%)';
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    document.body.style.overflow = '';
  }

  function renderShippingBar(cart) {
    if (!shippingMsgEl || !shippingFillEl) return;
    var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
    shippingFillEl.style.width = pct + '%';
    if (remaining > 0) {
      shippingMsgEl.textContent = 'Add ' + money(remaining) + ' more for free shipping';
    } else {
      shippingMsgEl.textContent = 'You\'ve unlocked free shipping!';
    }
  }

  function hasProtection(cart) {
    if (!PROTECTION_VARIANT_ID) return false;
    return cart.items.some(function (i) { return String(i.variant_id) === String(PROTECTION_VARIANT_ID); });
  }

  function protectionOptedOut() {
    try { return localStorage.getItem(PROTECTION_OFF_KEY) === '1'; } catch (e) { return false; }
  }

  function setProtectionVisual(on) {
    if (!protectionToggle) return;
    protectionToggle.setAttribute('aria-checked', on ? 'true' : 'false');
    protectionToggle.style.background = on ? '#C9A867' : '#46453F';
    var knob = protectionToggle.querySelector('span');
    if (knob) knob.style.transform = on ? 'translateX(16px)' : 'translateX(0)';
  }

  function renderProtectionToggle(cart) {
    if (!protectionToggle || !PROTECTION_VARIANT_ID) return;
    setProtectionVisual(hasProtection(cart));
  }

  function maybeAutoAddProtection(cart) {
    if (!PROTECTION_VARIANT_ID) return;
    if (protectionAutoAddInFlight) return;
    if (!cart.items.length) return;
    if (hasProtection(cart)) return;
    if (protectionOptedOut()) return;
    protectionAutoAddInFlight = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: PROTECTION_VARIANT_ID, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .catch(function () {})
      .then(function () { protectionAutoAddInFlight = false; });
  }

  function renderUpsell(cart) {
    if (!upsellEl || !upsellListEl) return;
    if (!cart.items.length || !UPSELL_PRODUCTS.length) {
      upsellEl.style.display = 'none';
      return;
    }
    var cartHandles = cart.items.map(function (i) { return i.handle; });
    var remaining = UPSELL_PRODUCTS.filter(function (p) {
      return p.available && p.variantId && cartHandles.indexOf(p.handle) === -1;
    });
    if (!remaining.length) {
      upsellEl.style.display = 'none';
      return;
    }
    upsellEl.style.display = 'block';
    upsellListEl.innerHTML = remaining.map(function (p) {
      var badge = p.isBundle
        ? '<div style="font-size:8.5px;letter-spacing:.06em;text-transform:uppercase;color:#C9A867;font-weight:700;margin-bottom:2px;">Collect all 3</div>'
        : '';
      return '' +
        '<div style="flex:0 0 92px;text-align:center;">' +
          '<a href="' + p.url + '" style="text-decoration:none;color:inherit;display:block;">' +
            '<div style="width:100%;aspect-ratio:1/1;background:#fff;overflow:hidden;margin-bottom:5px;">' +
              (p.image ? '<img src="' + p.image + '" style="width:100%;height:100%;object-fit:cover;">' : '') +
            '</div>' +
            badge +
            '<div style="font-size:10.5px;font-weight:600;line-height:1.25;">' + p.title + '</div>' +
            '<div style="font-size:9.5px;color:#9A978D;margin-top:1px;">' + money(p.price) + '</div>' +
          '</a>' +
          '<button type="button" class="vayl-upsell-add" data-variant-id="' + p.variantId + '" style="margin-top:5px;width:100%;background:#26272B;color:#EDEAE3;border:1px solid rgba(255,255,255,.16);padding:5px;font-size:9px;letter-spacing:.06em;text-transform:uppercase;font-weight:600;cursor:pointer;border-radius:100px;">+ Add</button>' +
        '</div>';
    }).join('');
  }

  function renderCart(cart) {
    document.querySelectorAll('.vayl-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    renderShippingBar(cart);
    renderUpsell(cart);
    renderProtectionToggle(cart);
    maybeAutoAddProtection(cart);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="color:#9A978D;padding:20px 0;">Your cart is empty.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item) {
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div style="font-size:12px;color:#9A978D;margin-top:2px;">' + item.variant_title + '</div>'
        : '';
      return '' +
        '<div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid rgba(255,255,255,.08);align-items:center;">' +
          '<div style="width:56px;height:56px;background:#fff;flex-shrink:0;overflow:hidden;">' +
            (item.image ? '<img src="' + item.image + '" style="width:100%;height:100%;object-fit:cover;">' : '') +
          '</div>' +
          '<div style="flex:1;">' +
            '<div style="font-size:13.5px;font-weight:600;">' + item.product_title + '</div>' +
            variantLine +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:8px;">' +
              '<button type="button" class="vayl-qty-btn" data-key="' + item.key + '" data-delta="-1" style="width:22px;height:22px;background:#26272B;color:#EDEAE3;border:1px solid rgba(255,255,255,.16);cursor:pointer;border-radius:4px;">−</button>' +
              '<span style="min-width:16px;text-align:center;font-size:13px;">' + item.quantity + '</span>' +
              '<button type="button" class="vayl-qty-btn" data-key="' + item.key + '" data-delta="1" style="width:22px;height:22px;background:#26272B;color:#EDEAE3;border:1px solid rgba(255,255,255,.16);cursor:pointer;border-radius:4px;">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="font-size:13.5px;font-weight:600;">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeQty(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var newQty = Math.max(0, item.quantity + delta);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  function addVariant(variantId, btn) {
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(openDrawer)
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  }

  function toggleProtection() {
    if (!protectionToggle || !PROTECTION_VARIANT_ID) return;
    var isOn = protectionToggle.getAttribute('aria-checked') === 'true';
    protectionToggle.disabled = true;
    var request = isOn
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PROTECTION_VARIANT_ID, quantity: 0 })
        })
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PROTECTION_VARIANT_ID, quantity: 1 })
        });
    request.then(function (r) { return r.json(); })
      .then(function () {
        try {
          if (isOn) {
            localStorage.setItem(PROTECTION_OFF_KEY, '1');
          } else {
            localStorage.removeItem(PROTECTION_OFF_KEY);
          }
        } catch (e) {}
        return fetchCart();
      })
      .catch(function () {})
      .then(function () { protectionToggle.disabled = false; });
  }

  function updateCheckoutHref() {
    if (!checkoutBtn) return;
    var code = discountInput ? discountInput.value.trim() : '';
    checkoutBtn.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }

  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.vayl-qty-btn');
    if (!btn) return;
    changeQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-delta'), 10));
  });

  if (upsellListEl) {
    upsellListEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.vayl-upsell-add');
      if (!btn) return;
      addVariant(btn.getAttribute('data-variant-id'), btn);
    });
  }

  if (protectionToggle) {
    protectionToggle.addEventListener('click', toggleProtection);
  }

  if (discountInput) {
    discountInput.addEventListener('input', updateCheckoutHref);
  }
  if (discountApplyBtn) {
    discountApplyBtn.addEventListener('click', function () {
      updateCheckoutHref();
      if (discountMsgEl) {
        discountMsgEl.textContent = discountInput && discountInput.value.trim()
          ? 'Code will be applied at checkout.'
          : '';
      }
    });
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart();
      openDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.vayl-cart-form')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(openDrawer)
      .catch(function () { form.submit(); });
  });

  fetchCart();
})();
